import * as React from 'react';
import Icon from './Icons';
import { Placement, Tooltip as UITooltip } from '@rtkwlf/ui';

type Props = {
  text: string;
  placement: Placement;
  className?: string;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
};

export const Tooltip: React.FunctionComponent<Props> = (props) => {
  const { placement, className, text, icon, style } = props;
  return (
    <div className={className} style={style}>
      <UITooltip
        placement={placement}
        overlay={
          <div className="p-2 text-center" style={{ width: '300px' }}>
            {text}
          </div>
        }
      >
        {!icon && <Icon.Question />}
        {icon && icon}
      </UITooltip>
    </div>
  );
};
